export { initialFrame } from './common';
export function web(options) {
  const fadeIn = style(options)[0];
  return [{
    ...fadeIn,
    keyframes: [{
      opacity: 0
    }, {
      opacity: 'var(--comp-opacity, 1)'
    }]
  }];
}
export function style(options) {
  return [{
    ...options,
    name: 'fadeIn',
    easing: 'sineInOut'
  }];
}
//# sourceMappingURL=FadeIn.js.map